// extracted by mini-css-extract-plugin
export default {"body":"GenericPageBodyWithGraphic_body__Hrbc4","image":"GenericPageBodyWithGraphic_image__WTAQF"};